import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class CookieService {

  /**
   * Set a cookie.
   * @param name  Cookie name
   * @param value Cookie value (will be JSON-stringified)
   * @param days  Number of days until expiry (omit for session cookie)
   */
  set(name: string, value: any, days?: number): void {
    let expires = '';
    if (days !== undefined) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    const encoded = encodeURIComponent(JSON.stringify(value));
    document.cookie = `${name}=${encoded}${expires}; path=/; SameSite=Strict`;
  }

  /**
   * Get a cookie value, parsed from JSON.
   */
  get<T = any>(name: string): T | null {
    const key = `${name}=`;
    const parts = document.cookie.split(';');
    for (let part of parts) {
      let c = part.trimStart();
      if (c.startsWith(key)) {
        try {
          return JSON.parse(decodeURIComponent(c.substring(key.length)));
        } catch {
          return null;
        }
      }
    }
    return null;
  }

  /**
   * Delete a cookie by name.
   */
  delete(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
  }
}

